import { gql } from '@apollo/client';

export const GET_BUSINESS_BRAND_BY_CATEGORY = gql`
	query GET_BRANDS_BY_BUSINESS_SERVICES($id: Int) {
		brandsByBusinessService(categoryId: $id) {
			id
			name
			brands {
				id
				url_logo
				contact_name
				name
			}
		}
	}
`;

export const GET_ALL_BUSINESS_PROVIDER = gql`
	query {
		getAllBizProvider {
			Advertising_PR_Media_MarketingAgencies {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			AdvisorGroups {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			AmazonSpend_E__tailerExperts {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			Certifiers {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			Consultants {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			ConsultingGroups {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			ContractManufacturers_PrivateLabel {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			Diagnostics {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			E__tailers {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			EcommerceMediaPlatform {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			Education_Training {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			EquipmentManufacturing {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			FinancialInstitutions {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			IndustryTech {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			IngredientSuppliers {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			Inspection {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			InvestmentBanking {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			Investor {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			Labs {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			Legal_Regulation_Compliance {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			Packaging {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			Plastics {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			Printing_Labels {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			QualityAssurance_QualityControl {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			SASPlatforms_Vendors {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			SamplingProviders {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			SearchEnginePlatforms {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			Shipping_Logistics {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			ShopperMarketing {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			Sustainability_ESGProviders {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			Testing {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			TradeSolutions {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
			VirtualBooth_TradeShowProviders {
				Maincatogory {
					MainCategoryid
					MainCategoryName
				}
				SubCategory {
					SubCategoryId
					SubCategoryName
				}
			}
		}
	}
`;

export const FILTER_BUSINESS_PROVIDER = gql`
	query getBrandsByBizProvider($bizfilters: [BizGenericFilter!]!) {
		getBrandsByBizProvider(bizfilters: $bizfilters) {
			id
			common_data {
				name
			}
		}
	}
`;
